import KendoButtonGroupMixin from './KendoButtonGroupMixin'

export default {
    name: 'kendo-buttongroup',
    mixins: [ KendoButtonGroupMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButtonGroup/index.js